import moment from 'moment';

const TIME_PERIODS_START = 8;
const TIME_PERIODS_END = 19;

const crossProduct = (a, b) => [].concat(...a.map(a => b.map(b => [].concat(a, b))));
// const combineDatesRanges = (dates, ranges: list[(start stop)]) -> [('yyyy-mm-dd hh-mm', 'yyyy-mm-dd hh-mm'), ...]
const combineDatesRanges = (dates, ranges) => {
	let result = [];
	for (let dateWithRange of crossProduct(dates, ranges)) {
		result.push(formatDateWithRange(dateWithRange));
	}
	return result;
}

const DATE_FORMAT = 'YYYY-MM-DD';
const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm';
const getDayStart = date => moment(date).startOf('day').toDate();
const dateToString = date => moment(date).startOf('day').format(DATE_FORMAT);
const datetimeToString = (date, defaultValue) => {
	const dateValue = moment(date);
	if (dateValue.isValid()) {
		return dateValue.format(DATETIME_FORMAT);
	}
	return (defaultValue != null) ? defaultValue : 'Invalid date';
};
const datesToStrings = dates => dates.map(dt => dateToString(dt));

// date, start, stop -> date start, date stop
const formatDateWithRange = dateWithRange => {
	return [dateWithRange[0] + ' ' + dateWithRange[1], dateWithRange[0] + ' ' + dateWithRange[2]]
}

// { date: "2023-01-17", time_from: "08:00", time_to: "08:00" } -> date start, date stop
const formatScheduleObjWithRange = scheduleObj => {
	return [scheduleObj.date + ' ' + scheduleObj.time_from, scheduleObj.date + ' ' + scheduleObj.time_to]
}

// getHourlyRanges из выбора юзера делаем пары start stop
const getHourlyRanges = (periods, start, end) => {
	if (periods.length === 0) {
		return [[start + ':00', end + ':00']];
	}
	let inPeriod = 0;
	let bigPeriods = [];
	for (let index = start; index < end; index++) {
		if (periods.includes(index)) {
			if (!inPeriod) {
				inPeriod = index;
			}
		} else {
			if (inPeriod) {
				bigPeriods.push([inPeriod, index]);
				inPeriod = 0;
			}
		}
	}
	if (inPeriod) {
		bigPeriods.push([inPeriod, end]);
	}
	if (bigPeriods.length === 1) {
		return [[bigPeriods[0][0] + ':00', bigPeriods[0][1] + ':00']];
	}
	let result = [];
	for (let period of bigPeriods) {
		result.push([period[0] + ':00', period[1] + ':00']);
	}
	return result;
}


const getSelectedTimeRangeText = (periods, start, end) => {
	let ranges = getHourlyRanges(periods, start, end);
	if (ranges.length === 1) {
		return 'Выбранный интервал: <strong>' + ranges[0][0] + '</strong> — <strong>' + ranges[0][1] + '</strong>';
	}
	let result = 'Выбранные интервалы:';
	for (let [start, end] of ranges) {
		result += '<br><strong>' + start + '</strong> — <strong>' + end + '</strong>';
	}
	return result;
}

const getMoment = value => {
	return moment(value, DATE_FORMAT + ' hh:mm');
}

// для одного врача поиск пересечения для каждой пары
const getScheduleIntersections = (periods1, periods2) => {
	let result = [];
	for (let [start1, end1, start2, end2] of crossProduct(periods1, periods2)) {
		if (
			getMoment(start1).isBetween(getMoment(start2), getMoment(end2), undefined, '[]') ||
			getMoment(end1).isBetween(getMoment(start2), getMoment(end2), undefined, '[]')
		) {
			result.push([start1, end1, start2, end2]);
		}
	}
	return result;
}

// по всем врачам и специальности выводим список где нет пересечений
const getAllSchedulesIntersections = (doctorsAndPeriods, userPeriods) => {
	let result = [];
	for (let [doctorUid, doctorName, periods] of doctorsAndPeriods) {
		result.push([doctorUid, doctorName, getScheduleIntersections(periods, userPeriods)]);
	}
	return result;
}


const getAllSchedulesIntersectionsFormatSafe = (doctorsData, doctorsCodes, selectedDays, selectedPeriods) => {
	let doctorsAndPeriods = [];
	let theOnlyDoctor = doctorsData.length === 1;
	for (let doctor of doctorsData) {
		if (
			theOnlyDoctor ||
			(doctorsCodes.length === 0 && doctor.autoGroup) ||
			doctorsCodes.includes(doctor.uid)
		) {
			doctorsAndPeriods.push([doctor.uid, doctor.name, doctor.schedule.map(formatScheduleObjWithRange)]);
		}
	}
	let userPeriods = combineDatesRanges(
		datesToStrings(selectedDays),
		getHourlyRanges(selectedPeriods, TIME_PERIODS_START, TIME_PERIODS_END),
	);
	return getAllSchedulesIntersections(doctorsAndPeriods, userPeriods);
}


export {
	getDayStart,
	dateToString,
	datetimeToString,
	datesToStrings,
	getSelectedTimeRangeText,
	getAllSchedulesIntersectionsFormatSafe,
	TIME_PERIODS_START,
	TIME_PERIODS_END,
}
